// 上报资源类型
export var RESOUCE_TYPE = { IMG: 1, JS: 2, CSS: 3, XHR: 4 };
// 要处理的标签
export var MONITOR_TAGS = ['script', 'link', 'img'];
